export default __webpack_public_path__ + "static/media/CM_JPEG.99f5aaa0.jpg";